<template>
  <div class="files-system" @dragover="handleDragOver">
    <template v-if="canCreateFiles || $store.getters.canCreateFileInGroup">
      <div v-show="showDrop" @drop="getData($event)" @dragover="handleDragOver" @dragleave="handleDragLeave"
        class="drag-area" dropzone="">
        <div>
          <p>Drop files here</p>
        </div>
      </div>
    </template>
    <div class="d-flex justify-content-between breadcrumb-body">
      <div class="breadcrumb-nav">
        <breadcrumb :path="$store.getters.GET_PATH" @browse_dir="browse_dir"
          v-if="$store.getters.GET_PATH && $store.getters.GET_PATH.length > 0"></breadcrumb>
      </div>

      <template v-if="$store.getters.GET_PATH.length">
        <div class="file-order" v-click-outside="outside">
          <div class="sort-order">
            <div class="top-files p-cursor" @click="show_sort_order">
              <img src="@/assets/tabler_sort-descending.svg" />&nbsp;

              <span class="d-none d-md-inline">
                <span>Sort</span>&nbsp;
                <span>
                  <img src="@/assets/dropdown-arrow.svg" />
                </span>
              </span>
            </div>
            <!--<div @click="show_sort_order">
            <img src="@/assets/icons8-ascending-sorting-15.png" /> Sort Files
          </div> -->
            <div class="sort-options" v-if="sort_order" @click="closedrop">
              <ul>
                <li @click="sort_type_action('dir')">
                  <span><img src="@/assets/icons8-checkmark-12.png" v-if="$store.getters.SORT_TYPE == 'dir'" /></span>Name
                </li>
                <li @click="sort_type_action('size')">
                  <span><img src="@/assets/icons8-checkmark-12.png"
                      v-if="$store.getters.SORT_TYPE == 'size'" /></span>Size
                </li>
                <li @click="sort_type_action('is_dir')">
                  <span><img src="@/assets/icons8-checkmark-12.png"
                      v-if="$store.getters.SORT_TYPE == 'is_dir'" /></span>Type
                </li>
                <li @click="sort_type_action('updatedAt')">
                  <span><img src="@/assets/icons8-checkmark-12.png"
                      v-if="$store.getters.SORT_TYPE == 'updatedAt'" /></span>Date
                </li>
              </ul>
              <ul>
                <li @click="sort_order_action('asc')">
                  <span><img src="@/assets/icons8-checkmark-12.png"
                      v-if="$store.getters.SORT_ORDER == 'asc'" /></span>Ascending Order
                </li>
                <li @click="sort_order_action('desc')">
                  <span><img src="@/assets/icons8-checkmark-12.png"
                      v-if="$store.getters.SORT_ORDER == 'desc'" /></span>Descending Order
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div :class="{ 'list-view-parent': fileview === 'list' }">
      <template v-if="$store.getters.GET_DB == 'sharedwithme'">
        <div v-if="fileview == 'list'" class="list-view">
          <table v-if="$store.getters.DIRECTORY_CHILDREN.length">
            <tr class="border-bottom">
              <td width="3%">
                <template v-if="!$store.getters.canCreateGroupFolder">
                  <svg style="width: 18px; height: 18px" viewBox="0 0 24 24" class="unchecked" v-if="
                    !$store.getters.SELECT_ALL &&
                    $store.getters.DIRECTORY_CHILDREN.length
                  " @click="select_all">
                    <path fill="#f9f9f9"
                      d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                  </svg>
                  <svg style="width: 18px; height: 18px" viewBox="0 0 24 24" class="unchecked" v-if="
                    $store.getters.SELECT_ALL &&
                    $store.getters.DIRECTORY_CHILDREN.length
                  " @click="select_all">
                    <path fill="#000000"
                      d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                  </svg>
                </template>
              </td>
              <td width="40%">
                <strong>Name</strong>
              </td>
              <td width="20%" v-if="$store.getters.GET_DB === 'sharedwithme'">
                <strong>Shared By</strong>
              </td>
              <td width="20%">
                <strong>Date Modified</strong>
              </td>
              <td width="20%">
                <strong>Size</strong>
              </td>
              <td></td>
            </tr>
            <tr v-for="(file, index) in $store.getters.DIRECTORY_CHILDREN" :key="index" draggable="true" :class="{
              highlighted: file.is_checked,
              read: file.is_viewed == true,
              unread: file.is_viewed == false,
            }">
              <td>
                <template v-if="file.is_group">
                  <template v-if="!file.is_group_parent">
                    <template v-if="file.action">
                      <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                        v-if="!file.is_checked && file.can_move" @click="check(index)">
                        <path
                          d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                      </svg>
                      <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                        v-if="file.is_checked && file.can_move" @click="check(index)">
                        <path fill="#05709e"
                          d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                      </svg>
                    </template>
                  </template>
                </template>
                <template v-if="!file.is_group">
                  <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                    v-if="!file.is_checked && file.can_move" @click="check(index)">
                    <path
                      d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                  </svg>
                  <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                    v-if="file.is_checked && file.can_move" @click="check(index)">
                    <path fill="#05709e"
                      d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                  </svg>
                </template>
              </td>
              <td class="browse_parent">
                <span @click="browse(index, file)" class="browse_folder truncate" :title="file.dir">
                  <ext :data="{ dir: file, index: index }"></ext>
                  <span>{{ str_text3(file.dir) }}</span>&nbsp;&nbsp;
                  <span class="favourite" v-if="file.is_favourite">
                    <i class="fa fa-star"></i>
                    <i class="fa fa-star"></i>
                  </span>
                </span>
              </td>
              <td v-if="$store.getters.GET_DB === 'sharedwithme'">
                {{ file.createdby }}
              </td>
              <td>
                {{ format_date2(file.createdAt) }}
              </td>
              <td>
                {{ $sizeFormat(file.size) }}
              </td>
              <td class="action-options" style="text-align: right">
                <template v-if="file.is_group">
                  <div class="showdropdown" ref="div" v-if="file.can_move" @click="showdropdown(index, $event)"
                    fill="#677888">
                    <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                      <path ref="path"
                        d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                    </svg>
                  </div>
                </template>
                <template v-if="!file.is_group">
                  <div class="showdropdown" ref="div" v-if="file.can_move" @click="showdropdown(index, $event)"
                    fill="#677888">
                    <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                      <path ref="path"
                        d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                    </svg>
                  </div>
                </template>
                <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                  <filedropdown :data="{ data: file, index: index }"></filedropdown>
                </div>
              </td>
            </tr>
          </table>
          <table v-if="!$store.getters.DIRECTORY_CHILDREN.length" class="no-files">
            <tr class="border-bottom">
              <td></td>
              <td width="60%">Name</td>
              <td>Modified</td>
              <td>Size</td>
              <td></td>
            </tr>
            <tr class="no-hover">
              <td align="center" colspan="5">
                <EmptyIllustration />
                <br />
                <span style="font-size: 20px"><strong>No files in
                    {{ $store.getters.GET_CURRENT_DIRECTORY }} folder</strong></span>
              </td>
            </tr>
          </table>
        </div>
        <div v-if="fileview == 'grid'" class="grid-view px-0">
          <div class="select-all">
            <span style="display: none" v-if="
              !$store.getters.SELECT_ALL &&
              $store.getters.DIRECTORY_CHILDREN.length
            " @click="select_all">
              <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
                <path fill="#f9f9f9"
                  d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
              </svg>
              Select all
            </span>
            <span style="display: none" v-if="
              $store.getters.SELECT_ALL &&
              $store.getters.DIRECTORY_CHILDREN.length
            " @click="select_all">
              <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
                <path fill="#000000"
                  d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
              </svg>
              Deselect all
            </span>
          </div>
          <div class="empty" v-if="!$store.getters.DIRECTORY_CHILDREN.length">
            <EmptyIllustration />
            <div>
              <span><strong>{{ $store.getters.GET_CURRENT_DIRECTORY }} is empty</strong></span>
              <br />
              <span style="font-size: 13px; line-height: normal"
                v-if="$store.getters.GET_CURRENT_DIRECTORY != 'Trash'">Drag file here to upload them to Fexspace Drive.
                <br />You can
                also add file by clicking New button.</span>
            </div>
          </div>
          <div class="grid-files" v-if="$store.getters.DIRECTORY_CHILDREN.length">
            <div v-for="(file, index) in $store.getters.DIRECTORY_CHILDREN" :id="genId(file.dir)" ref="index" :key="index"
              :class="{ highlighted: file.is_checked }">
              <template v-if="file.is_dir">
                <div class="header" :class="{
                  'd-flex justify-content-end': file.is_group_parent,
                  'give-header-height': !file.can_move,
                }">
                  <template v-if="file.is_group">
                    <div v-if="file.is_group_parent != true">
                      <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                        v-if="!file.is_checked && file.can_move" @click="check(index)">
                        <path fill="#f1f1f1"
                          d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                      </svg>
                      <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                        v-if="file.is_checked && file.can_move" @click="check(index)">
                        <path fill="#05709e"
                          d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                      </svg>
                    </div>
                    <div></div>
                  </template>
                  <template v-if="!file.is_group">
                    <div>
                      <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                        v-if="!file.is_checked && file.can_move" @click="check(index)">
                        <path fill="#f1f1f1"
                          d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                      </svg>
                      <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                        v-if="file.is_checked && file.can_move" @click="check(index)">
                        <path fill="#05709e"
                          d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                      </svg>
                    </div>
                    <div>
                      <template v-if="file.unpin || file.unpined">
                        <img src="@/assets/pin-dark.svg" />&nbsp;&nbsp;
                      </template>
                      <span class="favourite" v-if="file.is_favourite">
                        <img src="@/assets/star-dark.svg" />
                      </span>
                    </div>
                  </template>
                </div>
                <div class="file-ext">
                  <template v-if="!file.is_group">
                    <ext :data="{ dir: file, index: index }"></ext>
                  </template>
                  <template v-if="file.is_group">
                    <template v-if="file.is_group_parent">
                      <div class="mt-3">
                        <ext :data="{ dir: file, index: index }"></ext>
                      </div>
                    </template>
                    <template v-else>
                      <ext :data="{ dir: file, index: index }"></ext>
                    </template>
                  </template>
                </div>

                <div class="file-name d-flex flex-column header" :class="{
                  highlighted: file.is_checked,
                  read: file.is_viewed == true,
                  unread: file.is_viewed == false,
                }">
                  <span @click="browse(index, file)" class="can_browse text-truncate" :title="file.dir">
                    <ext class="ext-title" :data="{ dir: file, index: index, showImageIcon: true }"></ext>
                    {{ str_text(file.dir) }}
                  </span>
                  <div class="d-flex flex-row justify-content-between">
                    <span class="size">
                      {{ $sizeFormat(file.size) }}
                    </span>
                    <div class="file_dropdown_menu">
                      <div class="showdropdown" ref="div" v-if="file.can_move">
                        <svg style="width: 24px; height: 24px" viewBox="0 0 24 24" @click="showdropdown(index, $event)"
                          ref="svg" fill="#677888">
                          <path ref="path"
                            d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                        </svg>
                      </div>
                      <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                        <filedropdown :data="{ data: file, index: index }"></filedropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="!file.is_dir">
                <div @click.self="browse(index, file)" class="file-holder" :style="
                  isImage(file)
                    ? {
                      background: `url(${file.thumbnail})`,
                      //data.dir.thumbnail
                      //background: `url('https://images.unsplash.com/photo-1629581477374-9237dc216942?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTYzMjIyMzQ2Ng&ixlib=rb-1.2.1&q=80&w=1080')`,
                    }
                    : isVideo(file)
                      ? {
                        background: `url(${require('@/assets/play-video.jpg')})`,
                      }
                      : isPdf(file)
                        ? {
                          background: `url(${pdfCoverUrl(
                            file.file_id ? file.file_id : file.id
                          )})`,
                        }
                        : {}
                ">
                  <div class="header">
                    <div>
                      <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                        v-if="!file.is_checked && file.can_move" @click="check(index)">
                        <path fill="#f1f1f1"
                          d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                      </svg>
                      <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                        v-if="file.is_checked && file.can_move" @click="check(index)">
                        <path fill="#05709e"
                          d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                      </svg>
                    </div>
                    <div>
                      <template v-if="file.unpin || file.unpined">
                        <img src="@/assets/pin-dark.svg" />&nbsp;&nbsp;
                      </template>
                      <span class="favourite" v-if="file.is_favourite">
                        <img src="@/assets/star-dark.svg" />
                      </span>
                    </div>
                  </div>
                  <div v-if="!isImage(file) && !isVideo(file) && !isPdf(file)" class="file-ext">
                    <ext :data="{ dir: file, index: index }"></ext>
                  </div>
                </div>
                <div class="file-name d-flex flex-column header">
                  <span @click="browse(index, file)" class="can_browse text-truncate" :title="file.dir">
                    <ext class="ext-title" :data="{ dir: file, index: index, showImageIcon: true }"></ext>

                    {{ str_text(file.dir) }}
                  </span>
                  <div class="d-flex flex-row justify-content-between">
                    <span class="size">
                      {{ $sizeFormat(file.size) }}
                    </span>
                    <div class="file_dropdown_menu">
                      <div class="showdropdown" ref="div" v-if="file.can_move">
                        <svg style="width: 24px; height: 24px" viewBox="0 0 24 24" @click="showdropdown(index, $event)"
                          ref="svg" fill="#677888">
                          <path ref="path"
                            d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                        </svg>
                      </div>
                      <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                        <filedropdown :data="{ data: file, index: index }"></filedropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <template v-if="!$store.getters.GET_PATH.length">
          <template v-if="fileview == 'list'">
            <h4 class="mb-4">Recent Files</h4>
            <div class="empty-recent-file" v-if="!$store.getters.RECENT_FILES.length">
              <EmptyIllustration />
              <div>
                <span><strong>No recently opened file</strong></span>
                <br />
              </div>
            </div>
            <div style="height: auto" class="grid-files recent-files" v-if="$store.getters.RECENT_FILES.length">
              <div v-for="(file, index) in $store.getters.RECENT_FILES" :id="genId(file.dir)" ref="index" :key="index"
                draggable="true" :class="{ highlighted: file.is_checked }">
                <template v-if="file.is_dir">
                  <div class="header" :class="{
                    'd-flex justify-content-end': file.is_group_parent,
                    'give-header-height': !file.can_move,
                  }">
                    <template v-if="file.is_group">
                      <div v-if="file.is_group_parent != true">
                        <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="!file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#f1f1f1"
                            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#05709e"
                            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        </svg>
                      </div>
                      <div></div>
                    </template>
                    <template v-if="!file.is_group">
                      <div>
                        <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="!file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#f1f1f1"
                            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#05709e"
                            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        </svg>
                      </div>
                      <div></div>
                    </template>
                  </div>
                  <div class="file-ext">
                    <template v-if="!file.is_group">
                      <ext :data="{ dir: file, index: index }"></ext>
                    </template>
                    <template v-if="file.is_group">
                      <template v-if="file.is_group_parent">
                        <div class="mt-3">
                          <ext :data="{ dir: file, index: index }"></ext>
                        </div>
                      </template>
                      <template v-else>
                        <ext :data="{ dir: file, index: index }"></ext>
                      </template>
                    </template>
                  </div>
                  <div class="file-name d-flex flex-column header">
                    <span @click="browse(index, file)" class="can_browse text-truncate" :title="file.dir">
                      <ext class="ext-title" :data="{
                        dir: file,
                        index: index,
                        showImageIcon: true,
                      }"></ext>
                      <span>{{ str_text(file.dir) }}</span>
                    </span>
                    <div class="d-flex flex-row justify-content-between">
                      <span class="size">
                        {{ $sizeFormat(file.size) }}
                      </span>
                      <div class="file_dropdown_menu">
                        <div class="showdropdown" ref="div" v-if="file.can_move">
                          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24"
                            @click="showrecentfiledropdown(index, $event)" ref="svg" fill="#677888">
                            <path ref="path"
                              d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                          </svg>
                        </div>
                        <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                          <filedropdown :data="{ data: file, index: index }"></filedropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="!file.is_dir">
                  <div @click.self="browse(index, file)" class="file-holder" :style="
                    isImage(file)
                      ? {
                        background: `url(${file.thumbnail})`,
                        //data.dir.thumbnail
                        //background: `url('https://images.unsplash.com/photo-1629581477374-9237dc216942?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTYzMjIyMzQ2Ng&ixlib=rb-1.2.1&q=80&w=1080')`,
                      }
                      : isVideo(file)
                        ? {
                          background: `url(${require('@/assets/play-video.jpg')})`,
                        }
                        : isPdf(file)
                          ? {
                            background: `url(${pdfCoverUrl(
                              file.file_id ? file.file_id : file.id
                            )})`,
                          }
                          : {}
                  ">
                    <div class="header">
                      <div>
                        <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="!file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#f1f1f1"
                            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#05709e"
                            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        </svg>
                      </div>
                      <div></div>
                    </div>
                    <div v-if="!isImage(file) && !isVideo(file) && !isPdf(file)" class="file-ext">
                      <ext :data="{ dir: file, index: index }"></ext>
                    </div>
                  </div>
                  <div class="file-name d-flex flex-column header">
                    <span @click="browse(index, file)" class="can_browse text-truncate" :title="file.dir">
                      <ext class="ext-title" :data="{
                        dir: file,
                        index: index,
                        showImageIcon: true,
                      }"></ext>

                      <span>{{ str_text(file.dir) }}</span>
                    </span>
                    <div class="d-flex flex-row justify-content-between">
                      <span class="size">
                        {{ $sizeFormat(file.size) }}
                      </span>
                      <div class="file_dropdown_menu">
                        <div class="showdropdown" ref="div" v-if="file.can_move">
                          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24" @click="showdropdown(index, $event)"
                            ref="svg" fill="#677888">
                            <path ref="path"
                              d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                          </svg>
                        </div>
                        <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                          <filedropdown :data="{ data: file, index: index }"></filedropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <h4 class="h4-pin">Pinned File & Folders</h4>
            <table v-if="$store.getters.DIRECTORY_CHILDREN.length">
              <tr class="border-bottom">
                <td width="3%">
                  <template v-if="!$store.getters.canCreateGroupFolder">
                    <svg style="width: 18px; height: 18px" viewBox="0 0 24 24" class="unchecked" v-if="
                      !$store.getters.SELECT_ALL &&
                      $store.getters.DIRECTORY_CHILDREN.length
                    " @click="select_all">
                      <path fill="#f9f9f9"
                        d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                    </svg>
                    <svg style="width: 18px; height: 18px" viewBox="0 0 24 24" class="unchecked" v-if="
                      $store.getters.SELECT_ALL &&
                      $store.getters.DIRECTORY_CHILDREN.length
                    " @click="select_all">
                      <path fill="#000000"
                        d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                    </svg>
                  </template>
                </td>
                <td width="40%">
                  <strong>Name</strong>
                </td>
                <td width="20%" v-if="$store.getters.GET_DB === 'sharedwithme'">
                  <strong>Shared By</strong>
                </td>
                <td width="20%">
                  <strong>Date Modified</strong>
                </td>
                <td width="20%">
                  <strong>Size</strong>
                </td>
                <td></td>
              </tr>
              <tr v-for="(file, index) in $store.getters.DIRECTORY_CHILDREN" :key="index" draggable="true" :class="{
                highlighted: file.is_checked,
                read: file.is_viewed == true,
                unread: file.is_viewed == false,
              }">
                <td>
                  <template v-if="file.is_group">
                    <template v-if="!file.is_group_parent">
                      <template v-if="file.action">
                        <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="!file.is_checked && file.can_move" @click="check(index)">
                          <path
                            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#05709e"
                            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        </svg>
                      </template>
                    </template>
                  </template>
                  <template v-if="!file.is_group">
                    <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                      v-if="!file.is_checked && file.can_move" @click="check(index)">
                      <path
                        d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                    </svg>
                    <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                      v-if="file.is_checked && file.can_move" @click="check(index)">
                      <path fill="#05709e"
                        d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                    </svg>
                  </template>
                </td>
                <td class="browse_parent">
                  <span @click="browse(index, file)" class="browse_folder truncate" :title="file.dir">
                    <ext :data="{ dir: file, index: index }"></ext>
                    <span>{{ str_text3(file.dir) }}</span>&nbsp;&nbsp;
                    <span class="favourite" v-if="file.is_favourite">
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                    </span>
                  </span>
                </td>
                <td v-if="$store.getters.GET_DB === 'sharedwithme'">
                  {{ file.createdby }}
                </td>
                <td>
                  {{ format_date2(file.createdAt) }}
                </td>
                <td>
                  {{ $sizeFormat(file.size) }}
                </td>
                <td class="action-options" style="text-align: right">
                  <template v-if="file.is_group">
                    <div class="showdropdown" ref="div" v-if="file.can_move" @click="showdropdown(index, $event)"
                      fill="#677888">
                      <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                        <path ref="path"
                          d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                      </svg>
                    </div>
                  </template>
                  <template v-if="!file.is_group">
                    <div class="showdropdown" ref="div" v-if="file.can_move" @click="showdropdown(index, $event)"
                      fill="#677888">
                      <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                        <path ref="path"
                          d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                      </svg>
                    </div>
                  </template>
                  <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                    <filedropdown :data="{ data: file, index: index }"></filedropdown>
                  </div>
                </td>
              </tr>
            </table>
            <table v-if="!$store.getters.DIRECTORY_CHILDREN.length" class="no-files">
              <tr class="border-bottom">
                <td></td>
                <td width="60%">Name</td>
                <td>Modified</td>
                <td>Size</td>
                <td></td>
              </tr>
              <tr class="no-hover">
                <td align="center" colspan="5">
                  <EmptyIllustration />
                  <br />
                  <span style="font-size: 20px"><strong>No files in
                      {{ $store.getters.GET_CURRENT_DIRECTORY }} folder</strong></span>
                </td>
              </tr>
            </table>
          </template>
          <template v-else>
            <div v-if="fileview == 'grid'" class="grid-view home-files px-0">
              <h4 class="mb-4">Recent Files</h4>
              <div class="empty-recent-file" v-if="!$store.getters.RECENT_FILES.length">
                <EmptyIllustration />
                <div>
                  <span><strong>No recently opened file</strong></span>
                  <br />
                </div>
              </div>
              <div class="grid-files recent-files" v-if="$store.getters.RECENT_FILES.length">
                <div v-for="(recentfile, fileindex) in $store.getters.RECENT_FILES" :id="genId(recentfile.dir)"
                  ref="index" :key="fileindex" :class="{ highlighted: recentfile.is_checked }">
                  <template v-if="recentfile.is_dir">
                    <div class="header" :class="{
                      'd-flex justify-content-end': recentfile.is_group_parent,
                      'give-header-height': !recentfile.can_move,
                    }">
                      <template v-if="recentfile.is_group">
                        <div v-if="recentfile.is_group_parent != true">
                          <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="!recentfile.is_checked && recentfile.can_move" @click="check2(fileindex)">
                            <path fill="#f1f1f1"
                              d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                          </svg>
                          <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="recentfile.is_checked && recentfile.can_move" @click="check2(fileindex)">
                            <path fill="#05709e"
                              d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                          </svg>
                        </div>
                        <div></div>
                      </template>
                      <template v-if="!recentfile.is_group">
                        <div>
                          <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="!recentfile.is_checked && recentfile.can_move" @click="check2(fileindex)">
                            <path fill="#f1f1f1"
                              d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                          </svg>
                          <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="recentfile.is_checked && recentfile.can_move" @click="check2(fileindex)">
                            <path fill="#05709e"
                              d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                          </svg>
                        </div>
                        <div></div>
                      </template>
                    </div>
                    <div class="file-ext">
                      <template v-if="!recentfile.is_group">
                        <ext :data="{ dir: recentfile, index: fileindex }"></ext>
                      </template>
                      <template v-if="recentfile.is_group">
                        <template v-if="recentfile.is_group_parent">
                          <div class="mt-3">
                            <ext :data="{ dir: recentfile, index: fileindex }"></ext>
                          </div>
                        </template>
                        <template v-else>
                          <ext :data="{ dir: recentfile, index: fileindex }"></ext>
                        </template>
                      </template>
                    </div>

                    <div class="file-name d-flex flex-column header">
                      <span @click="browse(fileindex, recentfile)" class="can_browse text-truncate"
                        :title="recentfile.dir">
                        <ext class="ext-title" :data="{
                          dir: recentfile,
                          index: fileindex,
                          showImageIcon: true,
                        }"></ext>
                        {{ str_text(recentfile.dir) }}
                      </span>
                      <div class="d-flex flex-row justify-content-between">
                        <span class="size">
                          {{ $sizeFormat(recentfile.size) }}
                        </span>
                        <div class="file_dropdown_menu">
                          <div class="showdropdown" ref="div" v-if="recentfile.can_move">
                            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24"
                              @click="showrecentfiledropdown(fileindex, $event)" ref="svg" fill="#677888">
                              <path ref="path"
                                d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                            </svg>
                          </div>
                          <div class="file-dropdown" v-if="recentfile.show" v-on-clickaway="onClose">
                            <filedropdown :data="{ data: recentfile, index: fileindex }"></filedropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="!recentfile.is_dir">
                    <div @click.self="browse(fileindex, recentfile)" class="file-holder" :style="
                      isImage(recentfile)
                        ? {
                          background: `url(${recentfile.thumbnail})`,
                          //data.dir.thumbnail
                          //background: `url('https://images.unsplash.com/photo-1629581477374-9237dc216942?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTYzMjIyMzQ2Ng&ixlib=rb-1.2.1&q=80&w=1080')`,
                        }
                        : isVideo(recentfile)
                          ? {
                            background: `url(${require('@/assets/play-video.jpg')})`,
                          }
                          : isPdf(recentfile)
                            ? {
                              background: `url(${pdfCoverUrl(
                                recentfile.file_id ? recentfile.file_id : recentfile.id
                              )})`,
                            }
                            : {}
                    ">
                      <div class="header">
                        <div>
                          <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="!recentfile.is_checked && recentfile.can_move" @click="check(fileindex)">
                            <path fill="#f1f1f1"
                              d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                          </svg>
                          <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="recentfile.is_checked && recentfile.can_move" @click="check(fileindex)">
                            <path fill="#05709e"
                              d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                          </svg>
                        </div>
                        <div></div>
                      </div>
                      <div v-if="!isImage(recentfile) && !isVideo(recentfile) && !isPdf(recentfile)" class="file-ext">
                        <ext :data="{ dir: recentfile, index: fileindex }"></ext>
                      </div>
                    </div>
                    <div class="file-name d-flex flex-column header">
                      <span @click="browse(fileindex, recentfile)" class="can_browse text-truncate"
                        :title="recentfile.dir">
                        <ext class="ext-title" :data="{
                          dir: recentfile,
                          index: fileindex,
                          showImageIcon: true,
                        }"></ext>

                        {{ str_text(recentfile.dir) }}
                      </span>
                      <div class="d-flex flex-row justify-content-between">
                        <span class="size">
                          {{ $sizeFormat(recentfile.size) }}
                        </span>
                        <div class="file_dropdown_menu">
                          <div class="showdropdown" ref="div" v-if="recentfile.can_move">
                            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24"
                              @click="showdropdown(fileindex, $event)" ref="svg" fill="#677888">
                              <path ref="path"
                                d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                            </svg>
                          </div>
                          <div class="file-dropdown" v-if="recentfile.show" v-on-clickaway="onClose">
                            <filedropdown :data="{ data: recentfile, index: fileindex }"></filedropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <h4 class="h4-pin">Pinned File & Folders</h4>
              <div class="empty-recent-file" v-if="!$store.getters.DIRECTORY_CHILDREN.length">
                <EmptyIllustration />
                <div>
                  <span><strong>No pinned file</strong></span>
                  <br />
                </div>
              </div>
              <div class="grid-files pinned-files" v-if="$store.getters.DIRECTORY_CHILDREN.length">
                <div v-for="(file, index) in $store.getters.DIRECTORY_CHILDREN" :id="genId(file.dir)" ref="index"
                  :key="index" draggable="true" :class="{ highlighted: file.is_checked }" @dragenter="dragenter(file)"
                  @dragover="dragover(file)" @dragstart="dragstart(file, index)">
                  <template v-if="file.is_dir">
                    <div class="header" :class="{
                      'd-flex justify-content-end': file.is_group_parent,
                      'give-header-height': !file.can_move,
                    }">
                      <template v-if="file.is_group">
                        <div v-if="file.is_group_parent != true">
                          <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="!file.is_checked && file.can_move" @click="check(index)">
                            <path fill="#f1f1f1"
                              d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                          </svg>
                          <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="file.is_checked && file.can_move" @click="check(index)">
                            <path fill="#05709e"
                              d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                          </svg>
                        </div>
                        <div></div>
                      </template>
                      <template v-if="!file.is_group">
                        <div>
                          <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="!file.is_checked && file.can_move" @click="check(index)">
                            <path fill="#f1f1f1"
                              d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                          </svg>
                          <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="file.is_checked && file.can_move" @click="check(index)">
                            <path fill="#05709e"
                              d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                          </svg>
                        </div>
                        <div></div>
                      </template>
                    </div>
                    <div class="file-ext">
                      <template v-if="!file.is_group">
                        <ext :data="{ dir: file, index: index }"></ext>
                      </template>
                      <template v-if="file.is_group">
                        <template v-if="file.is_group_parent">
                          <div class="mt-3">
                            <ext :data="{ dir: file, index: index }"></ext>
                          </div>
                        </template>
                        <template v-else>
                          <ext :data="{ dir: file, index: index }"></ext>
                        </template>
                      </template>
                    </div>

                    <div class="file-name d-flex flex-column header">
                      <span @click="browse(index, file)" class="can_browse text-truncate" :title="file.dir">
                        <ext class="ext-title" :data="{
                          dir: file,
                          index: index,
                          showImageIcon: true,
                        }"></ext>
                        {{ str_text(file.dir) }}
                      </span>
                      <div class="d-flex flex-row justify-content-between">
                        <span class="size">
                          {{ $sizeFormat(file.size) }}
                        </span>
                        <div class="file_dropdown_menu">
                          <div class="showdropdown" ref="div" v-if="file.can_move">
                            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24"
                              @click="showdropdown(index, $event)" ref="svg" fill="#677888">
                              <path ref="path"
                                d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                            </svg>
                          </div>
                          <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                            <filedropdown :data="{ data: file, index: index }"></filedropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="!file.is_dir">
                    <div @click.self="browse(index, file)" class="file-holder" :style="
                      isImage(file)
                        ? {
                          background: `url(${file.thumbnail})`
                          //data.dir.thumbnail
                          //background: `url('https://images.unsplash.com/photo-1629581477374-9237dc216942?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTYzMjIyMzQ2Ng&ixlib=rb-1.2.1&q=80&w=1080')`,
                        }
                        : isVideo(file)
                          ? {
                            background: `url(${require('@/assets/play-video.jpg')})`,
                          }
                          : isPdf(file)
                            ? {
                              background: `url(${pdfCoverUrl(
                                file.file_id ? file.file_id : file.id
                              )})`,
                            }
                            : {}
                    ">
                      <div class="header">
                        <div>
                          <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="!file.is_checked && file.can_move" @click="check(index)">
                            <path fill="#f1f1f1"
                              d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                          </svg>
                          <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                            v-if="file.is_checked && file.can_move" @click="check(index)">
                            <path fill="#05709e"
                              d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                          </svg>
                        </div>
                        <div></div>
                      </div>
                      <div v-if="!isImage(file) && !isVideo(file) && !isPdf(file)" class="file-ext">
                        <ext :data="{ dir: file, index: index }"></ext>
                      </div>
                    </div>
                    <div class="file-name d-flex flex-column header">
                      <span @click="browse(index, file)" class="can_browse text-truncate" :title="file.dir">
                        <ext class="ext-title" :data="{
                          dir: file,
                          index: index,
                          showImageIcon: true,
                        }"></ext>

                        {{ str_text(file.dir) }}
                      </span>
                      <div class="d-flex flex-row justify-content-between">
                        <span class="size">
                          {{ $sizeFormat(file.size) }}
                        </span>
                        <div class="file_dropdown_menu">
                          <div class="showdropdown" ref="div" v-if="file.can_move">
                            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24"
                              @click="showdropdown(index, $event)" ref="svg" fill="#677888">
                              <path ref="path"
                                d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                            </svg>
                          </div>
                          <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                            <filedropdown :data="{ data: file, index: index }"></filedropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <div v-if="fileview == 'list'" class="list-view">
            <table v-if="$store.getters.DIRECTORY_CHILDREN.length">
              <tr class="border-bottom">
                <td width="3%">
                  <template v-if="!$store.getters.canCreateGroupFolder">
                    <svg style="width: 18px; height: 18px" viewBox="0 0 24 24" class="unchecked" v-if="
                      !$store.getters.SELECT_ALL &&
                      $store.getters.DIRECTORY_CHILDREN.length
                    " @click="select_all">
                      <path fill="#f9f9f9"
                        d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                    </svg>
                    <svg style="width: 18px; height: 18px" viewBox="0 0 24 24" class="unchecked" v-if="
                      $store.getters.SELECT_ALL &&
                      $store.getters.DIRECTORY_CHILDREN.length
                    " @click="select_all">
                      <path fill="#000000"
                        d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                    </svg>
                  </template>
                </td>
                <td width="40%">
                  <strong>Name</strong>
                </td>
                <td width="20%" v-if="$store.getters.GET_DB === 'sharedwithme'">
                  <strong>Shared By</strong>
                </td>
                <td width="20%">
                  <strong>Date Modified</strong>
                </td>
                <td width="20%" style="text-align: center">
                  <strong>Size</strong>
                </td>
                <td></td>
              </tr>
              <tr v-for="(file, index) in $store.getters.DIRECTORY_CHILDREN" :key="index" draggable="true"
                :class="{ highlighted: file.is_checked }">
                <td>
                  <template v-if="file.is_group">
                    <template v-if="!file.is_group_parent">
                      <template v-if="file.action">
                        <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="!file.is_checked && file.can_move" @click="check(index)">
                          <path
                            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#05709e"
                            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        </svg>
                      </template>
                    </template>
                  </template>
                  <template v-if="!file.is_group">
                    <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                      v-if="!file.is_checked && file.can_move" @click="check(index)">
                      <path
                        d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                    </svg>
                    <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                      v-if="file.is_checked && file.can_move" @click="check(index)">
                      <path fill="#05709e"
                        d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                    </svg>
                  </template>
                </td>
                <td class="browse_parent">
                  <span @click="browse(index, file)" class="browse_folder truncate" :title="file.dir">
                    <ext :data="{ dir: file, index: index, showImage: true }"></ext>{{ str_text(file.dir) }}
                    <span class="favourite" v-if="file.is_favourite">
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                    </span>
                  </span>
                </td>
                <td v-if="$store.getters.GET_DB === 'sharedwithme'">
                  {{ file.createdby }}
                </td>
                <td>
                  {{ format_date2(file.createdAt) }}
                </td>
                <td style="text-align: center">
                  {{ $sizeFormat(file.size) }}
                </td>
                <td class="action-options" style="text-align: right">
                  <template v-if="file.is_group">
                    <div class="showdropdown" ref="div" v-if="file.can_move" @click="showdropdown(index, $event)"
                      fill="#677888">
                      <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                        <path ref="path"
                          d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                      </svg>
                    </div>
                  </template>
                  <template v-if="!file.is_group">
                    <div class="showdropdown" ref="div" v-if="file.can_move" @click="showdropdown(index, $event)"
                      fill="#677888">
                      <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                        <path ref="path"
                          d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                      </svg>
                    </div>
                  </template>
                  <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                    <filedropdown :data="{ data: file, index: index }"></filedropdown>
                  </div>
                </td>
              </tr>
            </table>
            <table v-if="!$store.getters.DIRECTORY_CHILDREN.length" class="no-files">
              <tr class="border-bottom">
                <td></td>
                <td width="60%">Name</td>
                <td>Modified</td>
                <td>Size</td>
                <td></td>
              </tr>
              <tr class="no-hover">
                <td align="center" colspan="5">
                  <EmptyIllustration />
                  <br />
                  <span style="font-size: 20px"><strong>No files in
                      {{ $store.getters.GET_CURRENT_DIRECTORY }} folder</strong></span>
                </td>
              </tr>
            </table>
          </div>
          <div v-if="fileview == 'grid'" class="grid-view px-0">
            <div class="select-all">
              <span style="display: none" v-if="
                !$store.getters.SELECT_ALL &&
                $store.getters.DIRECTORY_CHILDREN.length
              " @click="select_all">
                <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
                  <path fill="#f9f9f9"
                    d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                </svg>
                Select all
              </span>
              <span style="display: none" v-if="
                $store.getters.SELECT_ALL &&
                $store.getters.DIRECTORY_CHILDREN.length
              " @click="select_all">
                <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
                  <path fill="#000000"
                    d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                </svg>
                Deselect all
              </span>
            </div>
            <div class="empty" v-if="!$store.getters.DIRECTORY_CHILDREN.length">
              <EmptyIllustration />
              <div>
                <span><strong>{{ $store.getters.GET_CURRENT_DIRECTORY }} is empty</strong></span>
                <br />
                <span style="font-size: 13px; line-height: normal"
                  v-if="$store.getters.GET_CURRENT_DIRECTORY != 'Trash'">Drag file here to upload them to Fexspace Drive.
                  <br />You
                  can also add file by clicking New button.</span>
              </div>
            </div>
            <div class="grid-files" v-if="$store.getters.DIRECTORY_CHILDREN.length">
              <div v-for="(file, index) in $store.getters.DIRECTORY_CHILDREN" :id="genId(file.dir)" ref="index"
                :key="index" draggable="true" :class="{ highlighted: file.is_checked }">
                <template v-if="file.is_dir">
                  <div class="header" :class="{
                    'd-flex justify-content-end': file.is_group_parent,
                    'give-header-height': !file.can_move,
                  }">
                    <template v-if="file.is_group">
                      <div v-if="file.is_group_parent != true">
                        <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="!file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#f1f1f1"
                            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#05709e"
                            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        </svg>
                      </div>
                      <div></div>
                    </template>
                    <template v-if="!file.is_group">
                      <div>
                        <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="!file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#f1f1f1"
                            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#05709e"
                            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        </svg>
                      </div>
                      <div>
                        <template v-if="file.unpin || file.unpined">
                          <img src="@/assets/pin-dark.svg" />&nbsp;&nbsp;
                        </template>
                        <span class="favourite" v-if="file.is_favourite">
                          <img src="@/assets/star-dark.svg" />
                        </span>
                      </div>
                    </template>
                  </div>
                  <div class="file-ext">
                    <template v-if="!file.is_group">
                      <ext :data="{ dir: file, index: index }"></ext>
                    </template>
                    <template v-if="file.is_group">
                      <template v-if="file.is_group_parent">
                        <div class="mt-3">
                          <ext :data="{ dir: file, index: index }"></ext>
                        </div>
                      </template>
                      <template v-else>
                        <ext :data="{ dir: file, index: index }"></ext>
                      </template>
                    </template>
                  </div>

                  <div class="file-name d-flex flex-column header">
                    <span @click="browse(index, file)" class="can_browse text-truncate" :title="file.dir">
                      <ext class="ext-title" :data="{ dir: file, index: index, showImageIcon: true }"></ext>
                      {{ str_text(file.dir) }}
                    </span>
                    <div class="d-flex flex-row justify-content-between">
                      <span class="size">
                        {{ $sizeFormat(file.size) }}
                      </span>
                      <div class="file_dropdown_menu">
                        <div class="showdropdown" ref="div" v-if="file.can_move">
                          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24" @click="showdropdown(index, $event)"
                            ref="svg" fill="#677888">
                            <path ref="path"
                              d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                          </svg>
                        </div>
                        <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                          <filedropdown :data="{ data: file, index: index }"></filedropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="!file.is_dir">
                  <div @click.self="browse(index, file)" class="file-holder" :style="
                    isImage(file)
                      ? {
                        background: `url(${file.thumbnail})`,
                        //data.dir.thumbnail
                        //background: `url('https://images.unsplash.com/photo-1629581477374-9237dc216942?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTYzMjIyMzQ2Ng&ixlib=rb-1.2.1&q=80&w=1080')`,
                      }
                      : isVideo(file)
                        ? {
                          background: `url(${require('@/assets/play-video.jpg')})`,
                        }
                        : isPdf(file)
                          ? {
                            background: `url(${pdfCoverUrl(
                              file.file_id ? file.file_id : file.id
                            )})`,
                          }
                          : {}
                  ">
                    <div class="header">
                      <div>
                        <svg class="unchecked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="!file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#f1f1f1"
                            d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                        <svg class="checked" style="width: 18px; height: 18px" viewBox="0 0 24 24"
                          v-if="file.is_checked && file.can_move" @click="check(index)">
                          <path fill="#05709e"
                            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        </svg>
                      </div>
                      <div>
                        <template v-if="file.unpin || file.unpined">
                          <img src="@/assets/pin-dark.svg" />&nbsp;&nbsp;
                        </template>
                        <span class="favourite" v-if="file.is_favourite">
                          <img src="@/assets/star-dark.svg" />
                        </span>
                      </div>
                    </div>
                    <div v-if="!isImage(file) && !isVideo(file) && !isPdf(file)" class="file-ext">
                      <ext :data="{ dir: file, index: index }"></ext>
                    </div>
                  </div>
                  <div class="file-name d-flex flex-column header">
                    <span @click="browse(index, file)" class="can_browse text-truncate" :title="file.dir">
                      <ext class="ext-title" :data="{ dir: file, index: index, showImageIcon: true }"></ext>

                      {{ str_text(file.dir) }}
                    </span>
                    <div class="d-flex flex-row justify-content-between">
                      <span class="size">
                        {{ $sizeFormat(file.size) }}
                      </span>
                      <div class="file_dropdown_menu">
                        <div class="showdropdown" ref="div" v-if="file.can_move">
                          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24" @click="showdropdown(index, $event)"
                            ref="svg" fill="#677888">
                            <path ref="path"
                              d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                          </svg>
                        </div>
                        <div class="file-dropdown" v-if="file.show" v-on-clickaway="onClose">
                          <filedropdown :data="{ data: file, index: index }"></filedropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
    <!--<div
      class="storage-premium"
      v-if="show_link"
      @click="invite"
      style="cursor:pointer"
    >
      <div class="go-premium">
        <span>
          <a><strong>Invite Link</strong></a>
            <svg
              style="width: 16px; height: 16px"
              viewBox="0 0 24 24"
              @click="close_link"
            >
              <path
                fill="currentColor"
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              />
            </svg>
        </span>
        <span class="more-space" style="font-size: 12px">Invite someone you will like to collaborate <br/>with on Fexspace.</span>
      </div>
    </div>-->
    <div class="storage-premium" v-if="show_storage_link && $store.getters.USER_PLAN != 1">
      <template v-if="$store.getters.ACCT_TYPE == 1 && $store.getters.ISTRIAL == true">
        <!--<div class="go-premium">
          <span>
            <router-link to="/my-plan"><strong>Go Premium</strong></router-link>
            <svg
              style="width: 16px; height: 16px"
              viewBox="0 0 24 24"
              @click="close_storage_link"
            >
              <path
                fill="currentColor"
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              />
            </svg>
          </span>
          <span class="more-space">Get more space for your storage</span>
        </div>-->
      </template>
      <template v-if="$store.getters.ACCT_TYPE == 2">
        <!--<div class="go-premium" v-if="$store.getters.ISSUPERADMIN == true && $store.getters.ISTRIAL == true">
              <span>
                <router-link to="/my-plan"><strong>Go Premium</strong></router-link>
                <svg style="width:16px;height:16px" viewBox="0 0 24 24" @click="close_storage_link">
                  <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                </svg>
              </span>
              <span class="more-space">Get more space for your storage</span>
            </div>-->
        <!--<div
          class="go-premium"
          v-if="
            $store.getters.ISSTAFF == true && $store.getters.ISTRIAL == true
          "
        >
          <span>
            <span>
              <a>Need more storage?</a>
            </span>
            <svg
              style="width: 16px; height: 16px"
              viewBox="0 0 24 24"
              @click="close_storage_link"
            >
              <path
                fill="currentColor"
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              />
            </svg>
          </span>
          <span style="cursor: pointer">Request more storage from Admin</span>
        </div>-->
      </template>
    </div>
    <startupload ref="startupload"></startupload>
  </div>
</template>
<style scoped>
.breadcrumb-body {
  padding: 1rem 0em 0 0em;
}

.drive-files {
  padding-top: 15px;
  border: 1px solid #ced8e1 !important;
}

.size {
  font-weight: normal !important;
}

.top-files {
  font-size: 12px;
}

.grid-view {
  background: transparent;
}

.files-system {
  font-family: "inter" !important;
}

.files-system h4 {
  font-size: 1.125rem;
  font-weight: 600;
}

.files-system .h4-pin {
  margin-top: 2rem;
  margin-bottom: 1.5rem;
}

.file-dropdown {
  background-color: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 4px;
  position: fixed;
  padding: 0.6em 0.6em;
  width: 230px;
  z-index: 100;
}

.file-dropdown ul li {
  display: flex;
  padding: 0.4em 0.6em;
  font-size: 13px;
  align-items: center;
}

.file-holder {
  background-size: cover !important;
  height: 104px;
}

.header div:last-child .file-dropdown .fa {
  font-size: 12px !important;
}

.header div:last-child .file-dropdown ul {
  margin-bottom: 0;
}

.header div:last-child .file-dropdown ul li {
  display: flex;
  padding: 0.4em 0.6em;
  font-size: 13px;
  align-items: center;
}

.header div:last-child .file-dropdown ul li.player {
  display: flex;
  padding: 1.1em 0.6em;
  font-size: 13px;
  align-items: center;
  width: 100%;
}

.header div:last-child .file-dropdown ul li .play {
  display: flex;
  align-items: center;
}

.header div:last-child .file-dropdown ul li .play svg {
  position: absolute;
  left: 2px;
  right: 10px;
}

.header div:last-child .file-dropdown ul li .play span {
  position: absolute;
  left: 26px;
}

.header div:last-child .file-dropdown ul li:hover {
  background: #fcfafa;
}

.header div:last-child .file-dropdown ul li.line-div:hover {
  background: #f1f1f1;
}

.header div:last-child .file-dropdown ul li.line-div {
  background: #f1f1f1;
  height: 1px;
  padding: 0;
  margin: 0.4em 0;
}

.header div:last-child .file-dropdown ul li i {
  margin-right: 0.9em;
}

.header div:last-child .file-dropdown ul li i.fa-trash {
  color: #f04040;
}

.header div:last-child .file-dropdown ul li i.fa-folder {
  color: #fbd348;
}

.file-name {
  /*background-color: #eaf0fa33;*/
  display: flex;
  justify-content: space-between;
  padding: 1em 0.9em;
  position: absolute;
  bottom: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  width: 100%;
}

.file-name .favourite {
  color: #f8c81a !important;
  font-size: 8px !important;
  position: absolute;
  top: 0;
  width: 20px;
  right: -20px;
}

.file-name>span:first-child {
  color: #333;
  font-size: 14px;
  position: relative;
}

.file-name span.can_browse {
  cursor: pointer;
  font-weight: 500;
}

.file-name span.can_browse .ext-title {
  width: 1rem;
  display: inline;
}

.file-name .size {
  font-size: 12px;
  font-weight: bold;
}

.file-ext .ext {
  text-align: center;
}

.grid-files .file-ext .ext .fa {
  font-size: 80px;
}

.list-view table td:nth-child(2) {
  width: 36rem;
  margin-right: 1rem;
}

.drag-area {
  position: absolute;
  width: inherit;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #f2f7fc;
  z-index: 50;
  padding: 1rem;
}

.drag-area div:first-of-type {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 0.25rem dashed #323232;
  font-weight: 600;
  font-size: 1.25rem;
  pointer-events: none;
}

@media only screen and (max-width: 960px) {
  .grid-files>div {
    height: 8.5rem;
  }

  .grid-files .header:first-of-type {
    padding: 0.5rem 0.5rem 0 0.5rem !important;
    height: 2rem !important;
  }

  .file-ext .ext {
    text-align: left;
    padding: 0 0.5rem !important;
  }

  .file-ext .mt-3 {
    margin: 0 !important;
  }

  .file-name {
    height: 3.75rem;
    padding: 0.5rem;
    justify-content: space-between;
    background-color: inherit;
  }

  .list-view table td:nth-child(1) {
    width: 1.5rem;
  }

  .list-view table td:nth-child(3),
  .list-view table td:nth-child(4) {
    display: none !important;
  }

  .list-view table tr {
    min-height: 3rem;
  }

  .list-view table {
    width: calc(100vw - 2rem);
  }

  .browse_parent .browser_folder {
    width: 60vw;
  }

  .list-view .browse_parent {
    min-height: 3.5rem !important;
    height: 3.5rem;
  }
}
</style>
<script>
/* eslint-disable camelcase */
import ClickOutside from "vue-click-outside";
import { mapMutations } from "vuex";
import filedropdown from "@/components/File-DropDown";
import ext from "@/components/File-Extension";
import { directive as onClickaway } from "vue-clickaway";
import moment from "moment";
import startupload from "@/components/Start-Upload";
import breadcrumb from "@/components/Breadcrumb";
import cookies from "@/services/cookies";
import { camelCase } from "lodash";
import EmptyIllustration from "./EmptyIllustration.vue";
import AuthenticationService from "@/services/AuthenticationService";
import { pdfCoverUrl } from "../utils";
export default {
  components: {
    filedropdown,
    breadcrumb,
    startupload,
    ext,
    EmptyIllustration,
  },
  data() {
    return {
      top: 0,
      left: 0,
      current_folder: "",
      is_select_all: false,
      filename: "",
      dropdown_index: 0,
      dropdown: false,
      show_storage_link: false,
      show_link: true,
      viewtype: this.$store.getters.VIEW_TYPE,
      sort_order: false,
      showDrop: false,
    };
  },
  computed: {
    showNewButton() {
      return this.$store.getters.showNewButton;
    },
    fileview: {
      get: function () {
        return this.$store.getters.VIEW_TYPE;
        // let view = localStorage.getItem('view_type') == null? this.$store.getters.VIEW_TYPE : localStorage.getItem('view_type')
        // console.log(view)
        // return view
      },
      set: function (type = "") {
        if (type === "" || type === undefined) {
          this.viewtype =
            this.$store.getters.GET_DB === "sharedwithme" ? "list" : "grid";
        } else {
          this.viewtype = type;
        }

        // console.log(this.viewtype)
        localStorage.setItem('view_type', this.viewtype)
        this.SET_VIEW_TYPE(this.viewtype);
        this.$forceUpdate()
      },
    },
    canCreateFiles: {
      get: function () {
        return this.$store.getters.canCreateFiles;
      },
    },
  },
  methods: {
    dragError(file_name) {
      // console.log(file_name)
      // console.log('Bale')
    },
    dragmoveprompt(folder, file) {
      this.$parent.dragmoveprompt(folder, file)
    },
    dragenter(file) {
      console.log(file)
    },
    dragover(file) {
      console.log(file)
    },
    dragstart(file, index) {
      // console.log('start')
      // console.log(file)
      localStorage.setItem('dragstart', JSON.stringify(file))
      localStorage.setItem('dragstartindex', JSON.stringify(index))
    },
    shareable_dialog(sharelink, id) {
      this.$parent.shareable_dialog(sharelink, id)
    },
    setShowDrop(drop) {
      this.showDrop = drop;
    },
    handleDragOver(e) {
      e.preventDefault();
      if (!this.showDrop && this.canCreateFiles) {
        this.setShowDrop(true);
      }

      if (!this.showDrop && this.$store.getters.canCreateFileInGroup) {
        this.setShowDrop(true);
      }
    },

    handleDragLeave(e) {
      e.preventDefault();
      this.setShowDrop(false);
    },

    outside() {
      this.sort_order = false;
    },
    closedrop(e) {
      if (
        e.target.nodeName === "LI" ||
        e.target.nodeName === "I" ||
        e.target.nodeName === "IMG" ||
        e.target.nodeName === "svg" ||
        e.target.nodeName === "SPAN"
      ) {
        this.sort_order = false;
      }
    },
    sort_type_action(type) {
      this.SET_SORT_TYPE(type);
      this.SORT_DIRECTORY_CHILDREN();
    },
    sort_order_action(order) {
      this.SET_SORT_ORDER(order);
      this.SORT_DIRECTORY_CHILDREN();
    },
    show_sort_order() {
      this.sort_order = !this.sort_order;
    },
    set_view_type(type) {
      this.fileview = type;
    },
    getd(e) {
      e.preventDefault();
    },
    invite(evt) {
      if (evt.target.nodeName !== "svg") {
        this.$parent.invite();
      }
    },
    genId(name) {
      return camelCase(name);
    },
    close_link() {
      this.show_link = !this.show_link;
    },
    close_storage_link() {
      this.show_storage_link = !this.show_storage_link;
    },
    close_dropdown() {
      this.dropdown = false;
    },
    view_file(index, id) {
      this.$parent.view_file(index, id);
    },
    play_video(index, id) {
      this.$parent.play_video(index, id);
    },
    play_audio(index, id) {
      this.$parent.play_audio(index, id);
    },
    // eslint-disable-next-line camelcase
    addusertofolder(id, folder_name) {
      this.$parent.addusertofolder(id, folder_name);
    },
    // eslint-disable-next-line camelcase
    editusertofolder(id, folder_name) {
      this.$parent.editusertofolder(id, folder_name);
    },
    sharefile(index = null, is_group = false) {
      this.$parent.sharefile(index, is_group);
    },
    editsharefileright(data, index) {
      this.$parent.editsharefileright(data, index);
    },
    getData(e, file = null) {
      e.preventDefault();
      this.setShowDrop(false);
      if (file == null) {
        this.$parent.drag_upload(
          e.dataTransfer.files,
          localStorage.getItem("current_directory_id")
        );
        // for (let i = 0; i < e.dataTransfer.files.length; i++) {
        //   console.log(e.dataTransfer.files)
        // }
      } else {
        if (file.is_dir) {
          this.$parent.drag_upload(e.dataTransfer.files, file.id);
          // for (let i = 0; i < e.dataTransfer.files.length; i++) {
          //   console.log(e.dataTransfer.files)
          // }
        } else {
          this.$parent.drag_upload(
            e.dataTransfer.files,
            localStorage.getItem("current_directory_id")
          );
          // for (let i = 0; i < e.dataTransfer.files.length; i++) {
          //   console.log(e.dataTransfer.files)

          // }
        }
      }
    },
    unpinfile(index, id) {
      this.$parent.unpinfile(index, id);
    },
    compressfile(index, src) {
      this.$parent.compressfile(index, src);
    },
    uncompressfile(index) {
      this.$parent.uncompressfile(index);
    },
    viewpdf(id, rights) {
      this.$parent.viewpdf(id, rights);
    },
    show_dropdown() {
      this.dropdown = !this.dropdown;
    },
    logincall() {
      this.$parent.logincall();
    },
    str_text(str) {
      if (this.$store.getters.VIEW_TYPE != "list") {
        if (str != null) {
          return str.length > 18 ? str.substr(0, 18) + "..." : str;
        }
      } else {
        if (str != null) {
          return str.length > 100 ? str.substr(0, 100) + "..." : str;
        }
      }
    },
    str_text2(str) {
      if (str != null) {
        return str.length > 100 ? str.substr(0, 100) + "..." : str;
      }
    },
    str_text3(str) {
      if (str != null) {
        return str.length > 60 ? str.substr(0, 60) + "..." : str;
      }
    },
    format_date2(val) {
      return moment(val).format("YYYY-MM-DD");
    },
    format_date(val) {
      return moment(val).format("YYYY-MM-DD HH:MM:SS A");
    },
    add_comment(name, id) {
      this.$parent.add_comment(name, id);
    },
    refreshfolder() {
      this.$parent.loading(true);
      let data = {
        token: cookies.getCookie("token"),
        current_directory_id: localStorage.getItem("current_directory_id"),
        db: localStorage.getItem("db"),
        filepath: sessionStorage.getItem("filepath"),
      };

      let that = this;

      this.$socket.emit("refresh", data, function (data) {
        if (data.data === true) {
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
          that.$parent.loading_close();
        }

        if (data.data === false) {
          that.$parent.loading_close();
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "SORT_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SET_FILE_INFO_DATA",
      "SET_CURRENT_FILE_ID",
      "SET_CURRENT_DIRECTORY",
      "SET_PATH",
      "HIDE_FILE_INFO",
      "SET_FILE_INDEX",
      "SET_FILES_INDEX",
      "SET_SELECT_ALL",
      "REMOVE_FILES_INDEX",
      "EMPTY_FILES_INDEX",
      "SET_SELECT_ALL",
      "SET_DB",
      "SET_CAN_CREATE",
      "SET_CREATE_RIGHT",
      "SET_EDIT_RIGHT",
      "SET_DOWNLOAD_RIGHT",
      "SET_PRINT_RIGHT",
      "SET_GROUP_CREATE_MODE",
      "SET_VIEW_TYPE",
      "SORT_DIRECTORY_CHILDREN",
      "SET_SORT_TYPE",
      "SET_SORT_ORDER",
      "SET_RECENT_FILES",
    ]),
    searchFolder() {
      this.SORT_STORED_DIRECTORY_CHILDREN();

      let that = this;
      let files = JSON.parse(
        JSON.stringify(this.$store.getters.STORED_DIRECTORY_CHILDREN)
      );
      if (this.filename) {
        let found = files.filter(function (file) {
          return file.dir.toLowerCase().includes(that.filename.toLowerCase());
        });
        this.SET_DIRECTORY_CHILDREN(found);
      } else {
        this.SET_DIRECTORY_CHILDREN(
          this.$store.getters.STORED_DIRECTORY_CHILDREN
        );
      }
    },
    closeDropDown(file) {
      file.show = false;
    },
    showmenu(index, file, e) {
      e.preventDefault();
    },
    async showrecentfiledropdown(index, e) {
      if (this.$store.getters.RECENT_FILES[index].show) {
        this.$store.getters.RECENT_FILES[index].show = false;
      } else {
        this.$store.getters.RECENT_FILES[index].show = true;
      }

      if (
        this.$store.getters.VIEW_TYPE === "list" ||
        this.$store.getters.GET_DB == "sharedwithme"
      ) {
        this.dropdown_index = index;
        // let elem = e.target.closest('.showdropdown')
        // let dropdown = elem.parentElement.querySelectorAll('.file-dropdown')
        // dropdown.style.right = '0px'
        return;
      } else {
        this.dropdown_index = index;
      }

      let elem = e.target.closest(".showdropdown");

      let { height, left } = elem.getBoundingClientRect();
      let top = e.y;
      await this.$nextTick();

      let dropdown = elem.parentElement.querySelector(".file-dropdown");

      if (!dropdown) return;
      let winHeight = window.innerHeight;
      let winWidth = window.innerWidth;

      let dem = dropdown.getBoundingClientRect();

      let dropdown_height = dem.height + height;
      let pos = winHeight - top;
      // let new_height = winHeight - dropdown_height
      let placement;

      if (pos < dropdown_height && top > dropdown_height) {
        placement = top - dropdown_height;
      } else {
        placement = pos > dropdown_height ? top : top - (dropdown_height - pos);
      }
      if (winWidth - left < dem.width) {
        dropdown.style.left = left - dem.width + "px";
      }

      console.log(placement)

      dropdown.style.top = placement + "px";
      this.SET_FILE_INDEX(index);

      let dex = 0;

      this.$store.getters.DIRECTORY_CHILDREN.map((dir) => {
        if (dex !== index) {
          dir.show = false;
        }
        dex++;
      });
    },
    async showdropdown(index, e) {
      if (this.$store.getters.DIRECTORY_CHILDREN[index].show) {
        this.$store.getters.DIRECTORY_CHILDREN[index].show = false;
      } else {
        this.$store.getters.DIRECTORY_CHILDREN[index].show = true;
      }

      if (
        this.$store.getters.VIEW_TYPE === "list" ||
        this.$store.getters.GET_DB == "sharedwithme"
      ) {
        this.dropdown_index = index;
        // let elem = e.target.closest('.showdropdown')
        // let dropdown = elem.parentElement.querySelectorAll('.file-dropdown')
        // dropdown.style.right = '0px'
        return;
      } else {
        this.dropdown_index = index;
      }

      let elem = e.target.closest(".showdropdown");

      let { height, left } = elem.getBoundingClientRect();
      let top = e.y;
      await this.$nextTick();

      let dropdown = elem.parentElement.querySelector(".file-dropdown");

      if (!dropdown) return;
      let winHeight = window.innerHeight;
      let winWidth = window.innerWidth;

      let dem = dropdown.getBoundingClientRect();

      let dropdown_height = dem.height + height;
      let pos = winHeight - top;
      // let new_height = winHeight - dropdown_height
      let placement;

      if (pos < dropdown_height && top > dropdown_height) {
        placement = top - dropdown_height;
      } else {
        placement = pos > dropdown_height ? top : top - (dropdown_height - pos);
      }
      if (winWidth - left < dem.width) {
        dropdown.style.left = left - dem.width + "px";
      }

      dropdown.style.top = placement + "px";
      this.SET_FILE_INDEX(index);

      let dex = 0;

      this.$store.getters.DIRECTORY_CHILDREN.map((dir) => {
        if (dex !== index) {
          dir.show = false;
        }
        dex++;
      });
    },
    onClose() {
      this.$store.getters.DIRECTORY_CHILDREN[this.dropdown_index].show = false;
      this.$store.getters.RECENT_FILES[this.dropdown_index].show = false;
    },
    browse_dir(dir) {
      if (dir[2] == "sharedwithme") {
        if (dir[1] == undefined) {
          let data = {
            token: cookies.getCookie("token"),
          };

          this.SET_FILE_ACTION("");
          this.HIDE_FILE_INFO();
          this.SET_SELECT_ALL(false);
          this.EMPTY_FILES_INDEX();

          let that = this;

          this.$socket.emit("get-shared-with", data, function (data) {
            if (data.data === true) {
              localStorage.setItem("current_directory_id", "");
              localStorage.setItem("current_directory", "Shared With Me");
              localStorage.setItem("db", "sharedwithme");
              that.SET_DB("sharedwithme");
              that.SET_DIRECTORY_CHILDREN(data.directory_children);
              that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
              that.SET_CURRENT_DIRECTORY("Shared With Me");
              that.SET_PATH(data.dir_path);
              that.SORT_DIRECTORY_CHILDREN();
            }

            if (data.data === false) {
              that.logincall();
              that.$router.push('/login')
            }
          });
        } else {
          let data = {
            token: cookies.getCookie("token"),
            current_directory_id: dir[1],
            db: dir[2],
            parent: dir[dir.length - 1],
          };

          let that = this;

          this.$socket.emit("browse", data, function (data) {
            if (data.data === true) {
              localStorage.setItem("current_directory_id", dir[1]);
              localStorage.setItem("current_directory", dir[0]);
              localStorage.setItem("db", dir[2]);
              that.SET_DB(dir[2]);
              that.SET_DIRECTORY_CHILDREN(data.directory_children);
              that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
              that.SET_CURRENT_DIRECTORY(dir[0]);
              that.SET_PATH(data.dir_path);
              that.SORT_DIRECTORY_CHILDREN();
            } else if (data.data === false) {
              that.logincall();
              that.$router.push('/login')
            }
          });
        }
      } else {
        let that = this;
        this.SET_FILE_ACTION("");
        this.HIDE_FILE_INFO();
        this.EMPTY_FILES_INDEX();
        this.SET_SELECT_ALL(false);

        let data = {
          db: dir[2],
          token: cookies.getCookie("token"),
          current_directory_id: dir[1],
        };

        this.$socket.emit("browse", data, function (data) {
          if (data.data === true) {
            localStorage.setItem("current_directory_id", dir[1]);
            localStorage.setItem("current_directory", dir[0]);
            localStorage.setItem("db", dir[2]);
            that.SET_DB(dir[2]);
            that.SET_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
            that.SET_CURRENT_DIRECTORY(dir[0]);
            that.SET_PATH(data.dir_path);
            that.SORT_DIRECTORY_CHILDREN();
          }

          if (data.data === false) {
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    notify(msg) {
      this.$parent.notify(msg);
    },
    browse(index = null, dir) {
      // console.log(dir);
      if (!dir.is_dir) {
        if (dir.extname === ".pdf") {
          if (dir.db === "sharedfiles" || dir.db === "sharedwithme") {
            this.viewpdf(dir.file_id, dir);
            return;
          }
          this.viewpdf(dir.id, dir);
        }

        if (dir.extname === ".txt") {
          if (dir.db === "sharedfiles" || dir.db === "sharedwithme") {
            this.view_txt(index, dir.file_id);
            return;
          }

          this.view_txt(index, dir.id);
        }

        if (
          dir.extname === ".tar" ||
          dir.extname === ".gz" ||
          dir.extname === ".zip"
        ) {
        }

        if (
          dir.extname === ".doc" ||
          dir.extname === ".docx" ||
          dir.extname === ".xls" ||
          dir.extname === ".xlsx" ||
          dir.extname === ".ppt" ||
          dir.extname === ".pptx"
        ) {
          if (dir.db === "group") {
            if (dir.edit_right === true) {
              this.$parent.view_file_doc(dir.id, "edit", dir.db);
            } else {
              this.$parent.view_file_doc(dir.id, "view", dir.db);
            }
            return;
          }

          if (dir.db === "public") {
            this.$parent.view_file_doc(dir.id, "edit", dir.db);
            return;
          }

          if (dir.db === "filesystem") {
            this.$parent.view_file_doc(dir.id, "edit", dir.db);
            return;
          }

          if (dir.db === "sharedfiles") {
            this.$parent.view_file_doc(dir.file_id, "edit", "filesystem");
            return;
          }

          if (dir.db === "sharedwithme") {
            dir.is_viewed = true;
            this.$forceUpdate();
            AuthenticationService.updatesharedfileviewstatus({
              id: dir.id,
              token: cookies.getCookie("token"),
            })
              .then((res) => {
                console.log(res);
              })
              .catch((err) => {
                console.log(err);
              });

            if (!dir.is_dir) {
              if (dir.edit) {
                this.$parent.view_file_doc(dir.file_id, "edit", dir.db);
              } else {
                this.$parent.view_file_doc(dir.file_id, "view", dir.db);
              }
              return;
            } else {
              console.log("tr");
            }
          }
        }

        if (dir.type === "image") {
          if (dir.db === "sharedfiles" || dir.db === "sharedwithme") {
            this.view_file(index, dir.file_id);
            return;
          }
          this.view_file(index, dir.id);
        }

        if (dir.type === "audio") {
          if (dir.db === "sharedfiles" || dir.db === "sharedwithme") {
            this.play_audio(index, dir.file_id);
            return;
          }
          this.play_audio(index, dir.id);
        }

        if (dir.type === "video") {
          if (dir.db === "sharedfiles" || dir.db === "sharedwithme") {
            this.play_video(index, dir.file_id);
            return;
          }
          this.play_video(index, dir.id);
        }

        return;
      }

      if (dir.is_approved === false && dir.is_group === true) {
        this.notify("This folder is not yet approved");
        return;
      }

      this.HIDE_FILE_INFO();
      this.SET_FILE_ACTION("");
      this.EMPTY_FILES_INDEX();
      this.SET_SELECT_ALL(false);

      if (dir.db === "sharedwithme") {
        dir.is_viewed = true;
        this.$forceUpdate();
        AuthenticationService.updatesharedfileviewstatus({
          id: dir.id,
          token: cookies.getCookie("token"),
        })
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }

      if (
        dir.is_group &&
        String(dir.id) === String(sessionStorage.getItem("gi"))
      ) {
        sessionStorage.setItem("is_group", dir.is_group);
        sessionStorage.setItem("create_mode", true);
        this.SET_GROUP_CREATE_MODE(sessionStorage.getItem("create_mode"));
      } else {
        sessionStorage.setItem("group_create", dir.create_right);
        sessionStorage.removeItem("create_mode");
        sessionStorage.setItem("is_group", dir.is_group);
        this.SET_GROUP_CREATE_MODE(false);
      }

      this.SET_CREATE_RIGHT(sessionStorage.getItem("group_create"));
      this.SET_DB(sessionStorage.getItem("group"));
      this.SET_CAN_CREATE(sessionStorage.getItem("create"));

      if (dir.id === undefined) {
        sessionStorage.setItem("create", false);
      } else {
        sessionStorage.setItem("create", true);
      }

      let data = {
        token: cookies.getCookie("token"),
        current_directory_id: dir.id,
        db: dir.is_group ? "group" : dir.db,
        parent: dir.parent,
      };

      let that = this;

      this.$socket.emit("browse", data, function (data) {
        // console.log(data);
        if (data.data === true) {
          localStorage.setItem("current_directory_id", dir.id);
          localStorage.setItem("current_directory", dir.dir);
          localStorage.setItem("db", dir.is_group ? "group" : dir.db);
          that.SET_DB(dir.is_group && dir.id == undefined ? "group" : dir.db);
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY(dir.dir);
          that.SET_CAN_CREATE(dir.can_create);
          if (dir.is_group) {
            that.SET_CREATE_RIGHT(dir.create_right);
            that.SET_EDIT_RIGHT(dir.edit_right);
            that.SET_DOWNLOAD_RIGHT(dir.download_right);
            that.SET_PRINT_RIGHT(dir.print_right);
          }
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
        } else if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    back() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;
      this.SET_FILE_ACTION("");
      this.HIDE_FILE_INFO();
      this.EMPTY_FILES_INDEX();
      this.SET_SELECT_ALL(false);

      this.$socket.emit("loadmainfiles", data, function (data) {
        if (data.data === true) {
          localStorage.setItem(
            "current_directory_id",
            data.current_directory_id
          );
          localStorage.setItem("current_directory", data.current_directory);
          localStorage.setItem("db", "filesystem");
          that.SET_DB("filesystem");
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY(data.current_directory);
          that.SET_RECENT_FILES(data.recentFiles);
          that.SET_PATH([]);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    show_file_info(file) {
      if (this.$store.getters.GET_CURRENT_ != file.dir) {
        this.$parent.loadCommentPreview(file.id);
      }

      this.SET_FILE_INFO_DATA(file);

      this.TOGGLE_FILE_INFO(file.dir);

      this.SET_CURRENT_FILE_ID(file.id);
    },
    add_favourite(index, id) {
      this.$parent.add_favourite(index, id);
    },
    remove_favourite(index, id) {
      this.$parent.remove_favourite(index, id);
    },
    renamefile(index, name, id) {
      this.$parent.renamefile(index, name, id);
    },
    deletefile(index, id) {
      this.$parent.deletefile(index, id);
    },
    deletefilepermanently(index, prompt = "") {
      this.$parent.deletefilepermanently(index, prompt);
    },
    restorefile(index) {
      this.$parent.restorefile(index);
    },
    view_txt(index, id) {
      this.$parent.view_txt(index, id);
    },
    edit_txt(index, id) {
      this.$parent.edit_txt(index, id);
    },
    copyto(index, is_shared = false) {
      this.$parent.copyto(index, is_shared);
    },
    moveto(index) {
      this.$parent.moveto(index);
    },
    select_all() {
      let that = this;
      if (!this.$store.getters.SELECT_ALL) {
        this.$store.getters.DIRECTORY_CHILDREN.map((file, index) => {
          if (!file.is_checked && file.can_move == true) {
            that.SET_FILE_ACTION(file.id);
            that.SET_FILES_INDEX([file.id, index]);
            file.is_checked = true;
          }
        });

        this.SET_SELECT_ALL(true);
      } else {
        this.$store.getters.DIRECTORY_CHILDREN.map((file, index) => {
          if (file.is_checked) {
            that.REMOVE_FILE_ACTION(file.id);
            that.REMOVE_FILES_INDEX(file.id);
            file.is_checked = false;
          }
        });

        this.SET_SELECT_ALL(false);
      }
    },
    create_doc(type) {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "You subscription period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'You subscription period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      }

      this.$parent.create(type);
    },
    trigger() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      }

      let up = document.querySelector("#file");
      up.click();
    },
    notifyexpiration(text) {
      this.$parent.notifyexpiration(text);
    },
    upload() {
      this.$parent.upload(this.$refs.file.files[0]);
      this.$refs.file.value = "";
    },
    pinfile(index, id) {
      this.$parent.pinfile(index, id);
    },
    check2(index) {
      if (!this.$store.getters.RECENT_FILES[index].can_move) {
        return;
      }

      if (this.$store.getters.RECENT_FILES[index].is_checked) {
        this.REMOVE_FILE_ACTION(
          this.$store.getters.RECENT_FILES[index].id
        );
        this.$store.getters.RECENT_FILES[index].is_checked = false;
        this.REMOVE_FILES_INDEX(
          this.$store.getters.RECENT_FILES[index].id
        );

        if (this.$store.getters.FILE_ACTION == 0) {
          this.SET_SELECT_ALL(false);
        }
      } else {
        this.SET_FILES_INDEX([
          this.$store.getters.RECENT_FILES[index].id,
          index,
        ]);
        this.SET_FILE_ACTION(this.$store.getters.RECENT_FILES[index].id);
        this.$store.getters.RECENT_FILES[index].is_checked = true;
      }
    },
    check(index) {
      if (!this.$store.getters.DIRECTORY_CHILDREN[index].can_move) {
        return;
      }

      if (this.$store.getters.DIRECTORY_CHILDREN[index].is_checked) {
        this.REMOVE_FILE_ACTION(
          this.$store.getters.DIRECTORY_CHILDREN[index].id
        );
        this.$store.getters.DIRECTORY_CHILDREN[index].is_checked = false;
        this.REMOVE_FILES_INDEX(
          this.$store.getters.DIRECTORY_CHILDREN[index].id
        );

        if (this.$store.getters.FILE_ACTION == 0) {
          this.SET_SELECT_ALL(false);
        }
      } else {
        this.SET_FILES_INDEX([
          this.$store.getters.DIRECTORY_CHILDREN[index].id,
          index,
        ]);
        this.SET_FILE_ACTION(this.$store.getters.DIRECTORY_CHILDREN[index].id);
        this.$store.getters.DIRECTORY_CHILDREN[index].is_checked = true;
      }
    },
    hide(index) {
      this.$store.getters.DIRECTORY_CHILDREN[index].show = false;
      this.$store.getters.RECENT_FILES[index].show = false;
    },
    hide_dropdown() {
      this.dropdown = false;
    },
    close_drop(e) {
      if (e.target.nodeName === "LI" || e.target.nodeName === "I") {
        this.dropdown = false;
      }
    },
    load() {
      this.$parent.load();
    },
    close_load() {
      this.$parent.close_load();
    },
    isVideo(file) {
      // console.log(file);
      try {
        let ext = file.extname ? file.extname : " ";
        if (ext) {
          ext = ext.split(".");
          ext = ext[ext.length - 1];
        }

        return ["mp4", "mov"].includes(ext.toLowerCase());
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    pdfCoverUrl,
    isPdf(file) {
      try {
        let ext = file.extname ? file.extname : " ";
        if (ext) {
          ext = ext.split(".");
          ext = ext[ext.length - 1];
        }

        return ["pdf", ".pdf"].includes(ext.toLowerCase());
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    isImage(file) {
      try {
        let ext = file.extname ? file.extname : " ";
        if (ext) {
          ext = ext.split(".");
          ext = ext[ext.length - 1];
        }
        return (
          ext.toLowerCase() === "jpg" ||
          ext.toLowerCase() === "png" ||
          ext.toLowerCase() === "PNG" ||
          ext.toLowerCase() === "jpeg" ||
          ext.toLowerCase() === "JPG" ||
          ext.toLowerCase() === "JPEG" ||
          ext.toLowerCase() === "gif" ||
          ext.toLowerCase() === "GIF"
        );
      } catch (err) {
        return false;
      }
    },
  },
  mounted() {
    this.SET_CREATE_RIGHT(sessionStorage.getItem("group_create"));
    this.SET_DB(sessionStorage.getItem("group"));
    this.SET_CAN_CREATE(sessionStorage.getItem("create"));
    this.SET_GROUP_CREATE_MODE(sessionStorage.getItem("create_mode"));
  },
  directives: {
    onClickaway: onClickaway,
    ClickOutside,
  },
};
</script>
